@if (isSubmitting()) {
  <p role="status" aria-live="polite">Salvando evento, ingressos, combos e camarotes. Aguarde a confirmação.</p>
}
<p-stepper [value]="1" orientation="vertical" [attr.inert]="isSubmitting() ? '' : null" [attr.aria-busy]="isSubmitting()">
  <p-step-item [value]="1" [class.step-invalid]="isStepInvalid(1)">
    <p-step>
      @if (isStepInvalid(1)) {
        <i class="pi pi-exclamation-circle step-invalid-icon"></i>
      }
      Informações Básicas do Evento
    </p-step>
    <p-step-panel>
      <ng-template #content let-activateCallback="activateCallback">
        <app-event-basic-info-step
          [formGroup]="formGroups.basicInfo"
          [eventCategories]="(eventCategories$ | async) ?? []"
          [initialBannerPreview]="initialBannerPreview"
          [initialMapPreview]="initialMapPreview"
          (mediaSelected)="onMediaSelected($event)"
          (mediaCleared)="onMediaCleared($event)" />

        <div class="actions">
          <app-button (btnClick)="onNext(1, activateCallback)" styleType="primary">Próximo</app-button>
        </div>
      </ng-template>
    </p-step-panel>
  </p-step-item>

  <p-step-item [value]="2" [class.step-invalid]="isStepInvalid(2)">
    <p-step>
      @if (isStepInvalid(2)) {
        <i class="pi pi-exclamation-circle step-invalid-icon"></i>
      }
      Data e horário
    </p-step>
    <p-step-panel>
      <ng-template #content let-activateCallback="activateCallback">
        <app-event-date-step [formGroup]="formGroups.eventDates" [allowPastDates]="!!eventId" />

        <div class="actions">
          <app-button (btnClick)="activateCallback(1)" styleType="outlined">Voltar</app-button>
          <app-button (btnClick)="onNext(2, activateCallback)" styleType="primary">Próximo</app-button>
        </div>
      </ng-template>
    </p-step-panel>
  </p-step-item>

  <p-step-item [value]="3" [class.step-invalid]="isStepInvalid(3)">
    <p-step>
      @if (isStepInvalid(3)) {
        <i class="pi pi-exclamation-circle step-invalid-icon"></i>
      }
      Endereço do Evento
    </p-step>
    <p-step-panel>
      <ng-template #content let-activateCallback="activateCallback">
        <app-event-address-step [formGroup]="formGroups.address" />

        <div class="actions">
          <app-button (btnClick)="activateCallback(2)" styleType="outlined">Voltar</app-button>
          <app-button (btnClick)="onNext(3, activateCallback)" styleType="primary">Próximo</app-button>
        </div>
      </ng-template>
    </p-step-panel>
  </p-step-item>

  <p-step-item [value]="4" [class.step-invalid]="isStepInvalid(4)">
    <p-step>
      @if (isStepInvalid(4)) {
        <i class="pi pi-exclamation-circle step-invalid-icon"></i>
      }
      Tipo e visibilidade do evento
    </p-step>
    <p-step-panel>
      <ng-template #content let-activateCallback="activateCallback">
        <app-event-type-step
          [formGroup]="formGroups.eventType"
          [isPrivateControl]="formGroups.eventSummary.controls.isPrivate"
          [eventId]="eventId"
          [ticketBatches]="ticketBatchesSignal()"
          (ticketBatchesChange)="onTicketBatchesChange($event)" />

        <div class="actions">
          <app-button (btnClick)="activateCallback(3)" styleType="outlined">Voltar</app-button>
          <app-button (btnClick)="onNext(4, activateCallback)" styleType="primary">Próximo</app-button>
        </div>
      </ng-template>
    </p-step-panel>
  </p-step-item>

  @if (!isFreePrivate) {
    <p-step-item [value]="5" [class.step-invalid]="isStepInvalid(5)">
      <p-step>
        @if (isStepInvalid(5)) {
          <i class="pi pi-exclamation-circle step-invalid-icon"></i>
        }
        Ingressos do Tipo Individual
      </p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <app-event-tickets-step
            [eventForm]="form"
            [eventId]="eventId"
            [ticketBatches]="ticketBatchesSignal()"
            [transitionDisabledReason]="hasUnsavedBatchChanges() ? 'Salve as alterações dos lotes antes de fazer a virada.' : ''"
            (batchesTransitioned)="onBatchTransitioned($event)"
            (batchMetadataSaved)="onBatchMetadataSaved($event)"
            (ticketBatchesChange)="onTicketBatchesChange($event)" />

          <div class="actions">
            <app-button (btnClick)="activateCallback(4)" styleType="outlined">Voltar</app-button>
            <app-button (btnClick)="onNext(5, activateCallback)" styleType="primary">Próximo</app-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>
  }

  @if (!isFreeEvent) {
    <p-step-item [value]="6">
      <p-step>Ingressos do Tipo Combo</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <app-event-combo-step
            [combos]="combosSignal()"
            [ticketBatches]="ticketBatchesSignal()"
            (combosChange)="onCombosChange($event)" />

          <div class="actions">
            <app-button (btnClick)="activateCallback(5)" styleType="outlined">Voltar</app-button>
            <app-button (btnClick)="onNext(6, activateCallback)" styleType="primary">Próximo</app-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>
  }

  @if (!isFreeEvent) {
    <p-step-item [value]="7">
      <p-step>Ingressos do Tipo Espaço</p-step>
      <p-step-panel>
        <ng-template #content let-activateCallback="activateCallback">
          <app-event-spaces-step
            [spaces]="spacesSignal()"
            [ticketBatches]="ticketBatchesSignal()"
            (spacesChange)="onSpacesChange($event)" />

          <div class="actions">
            <app-button (btnClick)="activateCallback(6)" styleType="outlined">Voltar</app-button>
            <app-button (btnClick)="onNext(7, activateCallback)" styleType="primary">Próximo</app-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-item>
  }

  <p-step-item [value]="8" [class.step-invalid]="isStepInvalid(8)">
    <p-step>
      @if (isStepInvalid(8)) {
        <i class="pi pi-exclamation-circle step-invalid-icon"></i>
      }
      Revise as informações do Evento
    </p-step>
    <p-step-panel>
      <ng-template #content let-activateCallback="activateCallback">
        <app-event-summary-step
          [eventForm]="form"
          [ticketBatches]="ticketBatchesSignal()"
          [combos]="combosSignal()"
          [spaces]="spacesSignal()"
          [eventCategories]="(eventCategories$ | async) ?? []"
          [eventInfo]="eventInfo"
          [eventId]="eventId"
          [transitionDisabledReason]="hasUnsavedBatchChanges() ? 'Salve as alterações dos lotes antes de fazer a virada.' : ''"
          (batchesTransitioned)="onBatchTransitioned($event)"
          (submitClick)="submit()" />

        @if (saveError(); as error) {
          <div class="save-error" role="alert">
            <strong>{{ error.title }}</strong>
            <ul>
              @for (detail of error.details; track $index) {
                <li>{{ detail }}</li>
              }
            </ul>
            <p>Os dados preenchidos foram mantidos nesta tela.</p>
          </div>
        }

        <div class="actions">
          <app-button (btnClick)="activateCallback(prevStepValue(8))" styleType="outlined">Voltar</app-button>
          <app-button (btnClick)="submit()" styleType="primary" [disabled]="isSubmitting()">Salvar</app-button>
        </div>
      </ng-template>
    </p-step-panel>
  </p-step-item>
</p-stepper>
